import React, {useState, useEffect, useContext} from 'react'
import { CdnImage, CdnPath } from '../../shared/cdn-image'
import axios from 'axios'
import Loader from '../../shared/loader'
import { navigate, useLocation } from "@reach/router"
import QuoteContext from "../quote-context";

const perPage = 12;

const Activities = ({ siteId, defaultActivities, eventTags, siteTags }) => {


	const {navigation, navigationDispatcher, formData, formDispatcher} = useContext(QuoteContext);
	const location = useLocation();

	const calculatePages = ( itemLength ) => {
		return Math.ceil( itemLength / perPage );
	}

	const [activities, setActivities] = useState( defaultActivities );
	const [page, setPage] = useState(1);
	const [pages, setPages] = useState( calculatePages( defaultActivities.length ) );

	const [filters, setFilters] = useState( {
		called: false,
		period:  'all',
		siteTags: [],
		eventTags: [],
	});

	const [loading, setLoading] = useState(false);
	const [day, setDay] = useState(location.state.day);

	useEffect(() => {
		window.scrollTo({
			top: 137,
			behavior: 'smooth'
		})
	}, [])

	useEffect(() => {
		if( filters.called ) {

			const payload = new FormData()
			payload.append( 'period', filters.period )
			payload.append( 'siteTag', filters.siteTags )
			payload.append( 'eventTag', filters.eventTags )

			setLoading(true);

			axios.post( '/quote/v2/filter/' + navigation.destination.slug + '/event', payload ).then(response => {
				setLoading(false);
				setPages( calculatePages( response.data.events.length ) );
				setPage(1);
				setActivities( response.data.events );
			}).catch(err => {
				setLoading(false);
				const message = ( err.response.data != null && err.response.data.message != undefined ) ? err.response.data.message : err.message;
				navigationDispatcher({type: "RAISE_ERROR", message: message, code: null });

				navigationDispatcher({
					type: 'TRACK_EVENT',
					action: 'error',
					category: 'load-errors',
					name: 'activity-filters',
					trigger: 'web-js',
					data:  {
						message: message,
						code: null
					}
				});
			});
		}
	}, [ filters ])


	const loadMore = () => {
		const nextPage = page +1;
		if( nextPage > pages ) {
			return false;
		}
		setPage( nextPage );

		navigationDispatcher({
			type: 'TRACK_EVENT',
			action: 'event',
			category: 'click',
			name: 'load-more',
			trigger: 'web-js',
			data:  {
				page: page
			}
		});
	}

	const sitePeriodFilter = ( period ) => {

		setFilters( {...filters, called: true, period: period } );

		navigationDispatcher({
			type: 'TRACK_EVENT',
			action: 'event',
			category: 'click',
			name: 'filter',
			trigger: 'web-js',
			data:  {
				type: 'period'
			}
		});

	};

	const siteTagFilter = ( id, event ) => {

		event.preventDefault();
		if( id == 'all' ) {
			setFilters( {...filters, called: true, siteTags: [] } );
		} else {
			if( filters.siteTags.includes( id ) ) {
				setFilters( {...filters, called: true, siteTags: filters.siteTags.filter(item => item != id) } );
			} else {
				const tags = filters.siteTags;
				tags.push( id );
				setFilters( {...filters, called: true, siteTags: tags } );
			}
		}

		navigationDispatcher({
			type: 'TRACK_EVENT',
			action: 'event',
			category: 'click',
			name: 'filter',
			trigger: 'web-js',
			data:  {
				type: 'siteTag'
			}
		});
	}

	const eventTagFilter = ( id, event ) => {

		event.preventDefault();
		if( id == 'all' ) {
			setFilters( {...filters, called: true, eventTags: [] } );
		} else {
			if( filters.eventTags.includes( id ) ) {
				setFilters( {...filters, called: true, eventTags: filters.eventTags.filter(item => item != id) } );
			} else {
				const tags = filters.eventTags;
				tags.push( id );
				setFilters( {...filters, called: true, eventTags: tags } );
			}
		}

		navigationDispatcher({
			type: 'TRACK_EVENT',
			action: 'event',
			category: 'click',
			name: 'filter',
			trigger: 'web-js',
			data:  {
				type: 'eventTag'
			}
		});

	}

	const items = activities.slice( 0, ( perPage * page ) );
	const selected = formData.activities.map(item => item.id);

	return (
		<>
			<div className="full-width-block white pd-v">
				<div className="row">
					<div className="column">
						<h2 className="mg-v">Add activities</h2>
					</div>
				</div>		
			</div>

			<div className="full-width-block">
				<div className="row no-padding">
					<div className="column">
						<div className="pd-h-dsk-md">
							<div className="content-block shadow-dsk radius">
								<div className="pd-dsk-md">
									{ siteId == 1 ?
									<div className="full-width-block">
										<div className="row no-padding">
											<div className="column">
												<div className="pd-h-tch">
													<div className="align-content vertical center split-mob tabs scrollable">
														<div className={`tab mg-r-dsk-lrg mg-r-tch` + ( filters.siteTags.length == 0 ? ` active` : '')} onClick={(event) => siteTagFilter( 'all', event )}><p className="nowrap">Show all</p></div>
																
														{siteTags.map( ( filter, index ) =>
															<div key={`site-tag-filter-` + filter.id} onClick={(event) => siteTagFilter( filter.id, event )} className={`tab mg-r-dsk-lrg mg-r-tch` + ( filters.siteTags.includes( filter.id ) ? ` active` : '')} >
																<p className="nowrap" dangerouslySetInnerHTML={{ __html: filter.name}}/>
															</div>
														)}
													</div>
												</div>
											</div>
										</div>
										<div className="divider"></div>
									</div>
									: null }
															
									<div className="full-width-block">
										<div className="row no-padding full-width">
											<div className="pd-h-tch">					
												
												<div className="align-content vertical center mg-v wrap-mobile radio-tabs">
													
													<div className="align-content vertical center fit-content mg-r-tch-sm mg-r-dsk mg-b-tch">
														<input
															id="all"
															type="radio" 
															name="period-filter" 
															aria-label="all" 
															onChange={() => sitePeriodFilter( 'all' )}
															checked={filters.period === 'all'}
														></input>
														<label htmlFor="all" className="pointer">
															View all
														</label>
													</div>
													
													<div className="align-content vertical center fit-content mg-r-tch-sm mg-r-dsk mg-b-tch">
														<input 
															id="daytime"
															type="radio" 
															name="period-filter" 
															aria-label="daytime" 
															onChange={() => sitePeriodFilter( 'day' )}
															checked={filters.period === 'day'}
														></input>
														<label htmlFor="daytime" className="pointer">
															Daytime activities
														</label>
													</div>

													<div className="align-content vertical center fit-content mg-r-tch-sm mg-r-dsk mg-b-tch">
														<input 
															id="evening"
															type="radio" 
															name="period-filter"
															aria-label="evening" 
															onChange={() => sitePeriodFilter( 'night' )} 
															checked={filters.period === 'night'}
														></input>
														<label htmlFor="evening" className="pointer">
															Evening activities
														</label>
													</div>

												</div>
											
											</div>
										</div>
									</div>
									<div className="full-width-block">
										<div className="row no-padding full-width">
											<div className="pd-h-tch">
												
													{ eventTags.length > 0 ? (
														<div className="align-content vertical center split-mob tabs scrollable">		
															{eventTags.map( ( filter, index ) =>
																<div key={`event-tag-filter-` + filter.id} onClick={(event) => eventTagFilter( filter.id, event )} className={`tab` + ( filters.eventTags.includes( filter.id ) ? ` active` : '')} dangerouslySetInnerHTML={{ __html: filter.name}} />
															)}
															<div className={`tab` + ( filters.eventTags.length == 0 ? ` active` : '')} onClick={(event) => eventTagFilter( 'all', event )}>Show all</div>
														</div>
													) : null }
												
											</div>
										</div>
									</div>

									{ loading ? (
										<Loader />
									) : (
										<>
											<div className="full-width-block">
												<div className="row no-padding full-width">
													<div className="pd-h-tch">
														<div className="align-content grid wrap">
														
															{ items.map( act => {

																return (

																	<div key={`act-` + act.id} className="grid-item one-quarter small-half mg-b">
																		<a className="align-content dir-col pointer" onClick={(event) => {

																			navigationDispatcher({
																				type: 'OPEN_MODAL',
																				modal: './quote/modal/activity',
																				title: act.name,
																				reviewScore: act.reviewScore,
																				payload: {

																					siteId: navigation.siteId,
																					locationId: navigation.destination.id,
																					id: act.id,
																					showAll:false,
																					day: day,
																					reviewScore: act.reviewScore,
																					selected: selected.includes(act.id),
																					hasButton: true,
																					allowAny: false,
																					date: location.state.date,
																					pax: formData.pax,
																					addEvent: ( selectedEvent  ) => {

																						formDispatcher({type:"ADD_ACTIVITY", event: selectedEvent});
																						navigationDispatcher({ type: "GOTO_STEP", step: "itinerary", params: null});
																						navigationDispatcher({
																							type: 'TRACK_EVENT',
																							action: 'event',
																							category: 'click',
																							name: 'add-activity',
																							trigger: 'web-js',
																							data: {
																								day: selectedEvent.day,
																								id: selectedEvent.id,
																								name: selectedEvent.name,
																								reviewScore: selectedEvent.reviewScore,
																								preferredTimeSlot: selectedEvent.preferredTimeSlot
																							}
																						});
																					}
																				}
																			})

																			navigationDispatcher({
																				type: 'TRACK_EVENT',
																				action: 'click',
																				name: 'view-activity',
																				category: 'pageview',
																				trigger: 'web-js',
																				data:  {
																					id: act.id,
																					name: act.name,
																					reviewScore: act.reviewScore
																				}
																			});
																		}}>
																		
																															
																			<div className={selected.includes(act.id) ? `full-width height-200 selected` : `full-width height-200`} style={navigation.siteId == 1 ? {marginBottom: "1rem", backgroundSize: "cover", backgroundImage: `url("${CdnPath( navigation.siteId, act.image )}")`, borderRadius: "0.3rem"} : {marginBottom: "0", backgroundSize: "cover", backgroundImage: `url("${CdnPath( navigation.siteId, act.image )}")`, borderTopLeftRadius: "0.5rem", borderTopRightRadius: "0.5rem"}}>
																				{ selected.includes(act.id) ? 
																					<div className="banner top fill primary pd radius-t">
																						<div className="align-content vertical horizontal center">
																							<span className="icon icon-tick white small-mob left"></span>
																							<span className="white text-xsmall-mob">Added to package</span>
																						</div>
																					</div> 
																				: null}
																				{act.tag != false ?
																				<div className="item__content--banner">
																					<span>{act.tag.name}</span>
																				</div>
																				: null }
																			</div>
																			<div className={navigation.siteId == 1 ? '' : 'bg-light-grey pd radius-b-lrg'}>
																				<p className="text-medium bold">{act.name}</p>
																				{act.reviewScore > 0 ?
																					<div className="align-content vertical center">
																						<div className="stars mg-v-sm mg-r-sm" style={{'--rating': act.reviewScore}}></div>
																						<span className='show-for-large'>View reviews</span>
																					</div>
																				: null }
																			</div>
																		
																	</a>
																</div>	
																)
															})}
														</div>
													</div>
												</div>
											</div>

											<div className="full-width-block">
												<div className="row">
													{ page < pages ? (
														<button className="button secondary inverted center radius fill-mob" onClick={loadMore}>Load More</button>
													) : null }
												</div>
											</div>
										</>
									)}
								</div>
							</div>
						</div>
						<div className="full-width-block white pd-v">
							<div className="row no-padding full-width">
								<div className="pd-h-tch pd-h-dsk-md">
									<button className="button secondary radius" onClick={() => {navigate('./')}}><span className="icon icon-chevron-left white small left"></span> Back</button>
								</div>
							</div>		
						</div>
					</div>
				</div>
			</div>
		</>
	)
}

export default Activities;
